import ErrorDisplay from "app/components/commonComponent/ErrorDisplay";
import Loader from "app/components/commonComponent/loader/Loader";
import ErrorBoundary from "app/helpers/ErrorBoundary";
import { masterDataModal } from "app/reducers/masterData/masterDataReducer";
import {
  getProformaInvoice,
  updateProformaInvoice,
} from "app/reducers/proformaInvoice/proformaInvoiceAction";
import { FC, useEffect } from "react";
import { Modal } from "react-bootstrap";
import { connect } from "react-redux";
import { useParams } from "react-router-dom";
import EditProformaInvoice from "./component/EditProformaInvoice";

interface props {
  proformaInvoiceDispatch: Function;
  proformaInvoiceData: any;
  proformaInvoiceLoading: boolean;
  proformaInvoiceError: string;
  masterDataList: {
    loading: boolean;
    masterData: masterDataModal;
    error: string;
  };
  showInvoice: { show: boolean; billId: number | undefined };
  closeModel: Function;
  updateProformaInvoiceDispatch: Function;
}

export interface task {
  ClientId: number;
  ClientName: string;
  Id: number;
  TaskCode: string;
}

export interface proformaInvoiceInitialValue {
  FirmId: number;
  FirmName: string;
  Discount: number;
  ClientId: number;
  TasksIds: { value: number; name: string }[];
  ClientName: string;
  ClientIds: { value: number; name: string }[];
  NewTaskIds: { value: number; name: string }[];
  TotalTaxAmount: number;
  TotalAmountWithoutTax: number;
  TotalAmount: number;
  BillNumber: string;
  IsProformaInvoice: boolean;
  Id: number;
}

const getInitialValue = (proformaInvoice: any): proformaInvoiceInitialValue => {
  return {
    Id: proformaInvoice?.Id,
    FirmId: proformaInvoice?.Firm?.Id,
    FirmName: proformaInvoice?.Firm?.Name,
    Discount: proformaInvoice?.Discount,
    TasksIds:
      proformaInvoice?.Tasks.map((task: task) => ({
        value: task.Id,
        name: task.TaskCode,
      })) || [],
    ClientId: proformaInvoice?.ClientId,
    ClientName: proformaInvoice?.ClientName,
    ClientIds: [],
    NewTaskIds: [],
    TotalTaxAmount: proformaInvoice?.TotalTaxAmount,
    TotalAmountWithoutTax: proformaInvoice?.TotalAmountWithoutTax,
    TotalAmount: proformaInvoice?.TotalAmount,
    BillNumber: proformaInvoice?.BillNumber,
    IsProformaInvoice: proformaInvoice?.IsProformaInvoice,
  };
};

const ProformaInvoiceForm: FC<props> = ({
  showInvoice,
  proformaInvoiceDispatch,
  proformaInvoiceData,
  proformaInvoiceLoading,
  proformaInvoiceError,
  masterDataList,
  closeModel,
  updateProformaInvoiceDispatch,
}) => {
  const params = useParams();

  useEffect(() => {
    if (!params.id && showInvoice.show && showInvoice.billId) {
      proformaInvoiceDispatch(showInvoice.billId);
    }
  }, [showInvoice.billId]);

  

  return (
    <ErrorBoundary>
      <Modal
        show={showInvoice.show}
        aria-labelledby="contained-modal-billing"
        centered
        data-toggle="modal"
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header>
          <Modal.Title>Update Proforma Invoice {!proformaInvoiceLoading ? "- " + proformaInvoiceData?.data?.records?.BillNumber : ""}</Modal.Title>
        </Modal.Header>
        {proformaInvoiceLoading ? (
          <div className="py-5">
            <Loader />
          </div>
        ) : proformaInvoiceError ? (
          <ErrorDisplay error={proformaInvoiceError} />
        ) : (
          <EditProformaInvoice
            initialValue={getInitialValue(proformaInvoiceData?.data?.records)}
            masterDataList={masterDataList}
            closeModel={closeModel}
            updateInvoiceDispatch={updateProformaInvoiceDispatch}
          />
        )}
      </Modal>
    </ErrorBoundary>
  );
};

const mapStateToProps = (state: any) => {
  return {
    proformaInvoiceLoading: state.proformaInvoice.loading,
    proformaInvoiceData: state.proformaInvoice.proformaInvoice,
    proformaInvoiceError: state.proformaInvoice.error,
    masterDataList: state.masterData,
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    proformaInvoiceDispatch: (invoiceId: number) =>
      dispatch(getProformaInvoice(invoiceId)),
    updateProformaInvoiceDispatch: (data: any, successCallback: Function) =>
      dispatch(updateProformaInvoice(data, successCallback)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ProformaInvoiceForm);
